
<div class="multiroom-container-stats" v-if="!getStyleEdition">
    <p class="multiroom-container-stats_text">
        {{ getAllInfos.restoName }} -
    </p>

    <popup-resa-details :date="getSelectedDay" :service="getSelectedMainService"
        :title="`${getOccupationByServiceAndDay(getSelectedDay, getSelectedMainService)}/${getAllCouvForAllRooms}<span class='popup-resa-detail-title-couvor'> couverts</span> - `" />

    <p class="popup-resa-detail-occupation"><span class="popup-resa-detail-occupation-text">Occupation:</span>
        <span class="popup-resa-detail-occupation-percentage"> {{
            getPercentOccupation }} %</span>
    </p>

    <el-popover placement="bottom" width="200" v-model="popupStateService" popper-class="popup-delete black-inputs">
        <p>Êtes vous sûr ?</p>

        <div style="text-align: right; margin: 0">
            <el-button size="mini" class="dark" type="primary" @click="popupStateService = false">
                Annuler
            </el-button>

            <el-button type="primary" size="mini" @click="setStateService">
                Confirmer
            </el-button>
        </div>

        <span slot="reference">
            <span class="multiroom-container-stats_red" v-if="getCurrentServiceLockState">
                - <span class="multiroom-container-stats_red-service">Service</span> fermé
            </span>
            <span class="multiroom-container-stats_green" v-else>
                - <span class="multiroom-container-stats_green-service">Service</span> ouvert
            </span>
        </span>
    </el-popover>

    <popup-discount-display :date="getSelectedDay" :service="getSelectedMainService" />

    <span v-if="cashState(getSelectedMainService)">
        - <span class="multiroom-container-stats_cash-type-desk">{{ cashState(getSelectedMainService).type }}</span>
        <span class="multiroom-container-stats_cash-type-mob">{{ cashState(getSelectedMainService).type[0]
            }}:</span>
        {{ cashState(getSelectedMainService).value }}€ / c
    </span>

    <span v-if="cashState(getSelectedMainService).nbCouv">
        ({{ cashState(getSelectedMainService).nbCouv }})
    </span>
</div>
